export default "__VITE_ASSET__CYnjJtgi__"